/* eslint-disable no-restricted-syntax */
import * as React from 'react';

import { Box, Col, Row, StyleSheet, fontFamily } from '@coursera/coursera-ui';

import { TriggerEvent } from 'bundles/internal-enterprise/components/InternalThirdPartyOrganizationPage/constants/AutoEnrollmentConstants';
import DropdownMenu from 'bundles/internal-ui/components/forms/DropdownMenu';
import TextBox from 'bundles/internal-ui/components/forms/TextBox';

import _t from 'i18n!nls/internal-enterprise';

type Props = {
  handleTargetCourseIdInput: (id: React.SyntheticEvent<HTMLInputElement>) => void;
  targetCourseId?: string;
  setTriggerType: (trigger: string) => void;
  triggerType?: TriggerEvent;
  handleTriggeredByCourseInput: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  triggeredByCourseId?: string;
};

const styles = StyleSheet.create({
  labels: {
    fontFamily: fontFamily.bold,
    fontSize: '14px',
    lineHeight: '24px',
  },
});

export const AutoEnrollmentForm: React.FC<Props> = ({
  handleTargetCourseIdInput,
  targetCourseId,
  setTriggerType,
  triggerType,
  handleTriggeredByCourseInput,
  triggeredByCourseId,
}) => {
  return (
    <Box flexDirection="column">
      <Row alignItems="start" rootClassName={styles.labels}>
        <Col col={3}>{_t('Enroll Learners in Course')}</Col>
        <Col col={3}>{_t('Based on Enrollment Trigger')}</Col>
        <Col col={3}>{_t('Triggered By Course')}</Col>
      </Row>
      <Row alignItems="center">
        <Col col={3}>
          <TextBox
            placeholder={_t('Enter Course ID')}
            onUpdateField={handleTargetCourseIdInput}
            currentValue={targetCourseId}
          />
        </Col>
        <Col col={3}>
          <DropdownMenu
            onChange={(event) => {
              setTriggerType(event.target.value);
            }}
            value={triggerType}
            options={[
              { label: _t('On Joining Program'), value: TriggerEvent.JOIN_PROGRAM },
              { label: _t('On completion of'), value: TriggerEvent.COMPLETE_COURSE },
              { label: _t('On enrollment of'), value: TriggerEvent.ENROLL_IN_COURSE },
            ]}
          />
        </Col>
        <Col col={3}>
          <TextBox
            onUpdateField={handleTriggeredByCourseInput}
            currentValue={triggerType === TriggerEvent.JOIN_PROGRAM ? '' : triggeredByCourseId}
            placeholder={triggerType === TriggerEvent.JOIN_PROGRAM ? _t('Not Applicable') : _t('Enter Course Id')}
            disabled={triggerType === TriggerEvent.JOIN_PROGRAM}
          />
        </Col>
      </Row>
    </Box>
  );
};
